const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Deliberately not Intl/toLocaleDateString: its month abbreviation varies by
// ICU data across browsers/Node versions (e.g. en-GB renders "12 Sept 2026"
// in some environments, "12 Sep 2026" in others) - undermining the one
// requirement this exists for, a format that's identical everywhere.
//
// Deliberately UTC getters, not local ones: a bare "YYYY-MM-DD" value (e.g.
// a MySQL DATE column, as Estimation's valid_until is) is parsed by `new
// Date()` as UTC midnight - reading it back with local getters rolls the
// displayed date back by one day in any timezone behind UTC. UTC getters
// are correct for that case AND for a full ISO timestamp (already UTC),
// so using them everywhere is what "identical everywhere" actually requires.
export function formatReportDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${day} ${MONTHS[date.getUTCMonth()]} ${date.getUTCFullYear()}`;
}

// Same dd/Mon/yyyy shape as formatReportDate, hyphen-separated - the
// Estimation screens' display convention (list, detail, PDF) for dates
// like "Valid Until", kept as its own export rather than a formatting
// option on formatReportDate so existing callers/snapshots don't shift.
export function formatDateHyphenated(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${day}-${MONTHS[date.getUTCMonth()]}-${date.getUTCFullYear()}`;
}
